import { useContext } from "react";

// context
import FormSelectDialogContext from "./index";

// store
import { actionTypes } from "./store";

export const useFormSelectDialog = () => {
    const { state, dispatch, ...extraProps } = useContext(
        FormSelectDialogContext
    );

    // Action Creators
    const setHasOpenedBefore = hasOpenedBefore => {
        dispatch({
            type: actionTypes.SET_HAS_OPENED_BEFORE,
            hasOpenedBefore
        });
    };
    const setIsOpen = isOpen => {
        dispatch({
            type: actionTypes.SET_IS_OPEN,
            isOpen
        });
    };
    const setOpenCloseButtonIsInFocus = openCloseButtonIsInFocus => {
        dispatch({
            type: actionTypes.SET_OPEN_CLOSE_BUTTON_IS_IN_FOCUS,
            openCloseButtonIsInFocus
        });
    };

    return {
        ...state,
        ...extraProps,
        setIsOpen,
        setHasOpenedBefore,
        setOpenCloseButtonIsInFocus
    };
};
